module.exports = ".card-title {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n"